export default __webpack_public_path__ + "static/media/quitarDeRevision.9d973b13.svg";